import React from "react";
import {FooterFontSize, FooterStyle, Link, SpanImg, TitleContainer, TosContainer} from "./Footer.css";
import appleStore from '/assets/apple-store.svg?url';
import playStore from '/assets/play-store.svg?url';
import {useNavigate} from "react-router-dom";
import {HideOnMobile} from "../../global.css";

function Footer() {
    const navigate = useNavigate()
    return (
        <div className={FooterStyle}>
            <div className={TitleContainer}>
                <div className={`${FooterFontSize}`}>
                    <span>Pour un usage optimal sur smartphone, l’application est disponible sur</span>
                    <a className={Link} target={"blank"} href={"https://apps.apple.com/fr/app/pouyanne-app/id1617055785"}> App Store <img className={SpanImg} src={appleStore} alt={"Apple Logo"}/></a>
                    <span> et</span>
                    <a className={Link} target={"blank"} href={"https://play.google.com/store/apps/details?id=com.pouyanne.pouyanneapp"}> Google Play <img className={SpanImg} src={playStore} alt={"Google Logo"}/></a>
                </div>
            </div>
            <div className={`${TosContainer} ${FooterFontSize}`}>
                <span>Tous droits réservés</span>
                <span>Copyright 2024</span>
                <span className={HideOnMobile}>-</span>
                <a className={Link} target={"blank"} href={"https://www.pouyanne.fr"}>Banque Pouyanne</a>
                <span className={HideOnMobile}>-</span>
                <button className={Link} onClick={() => navigate("/home/kpi")}>KPI</button>
                <span className={HideOnMobile}>-</span>
                <a className={Link} target={"blank"} href={"https://www.pouyanne.fr/fr/pages/en-cas-durgence"}>Numéros d'urgence</a>
                <span className={HideOnMobile}>-</span>
                <a className={Link} target={"blank"} href={"https://www.pouyanne.fr/fr/pages/politique-de-confidentialite"}>Politique de confidentialité</a>
                <span className={HideOnMobile}>-</span>
                <a className={Link} target={"blank"} href={"https://www.pouyanne.fr/fr/pages/mentions-legales"}>Mentions légales</a>
            </div>
        </div>
    );
}

export default Footer;